import TrailDetailsDaysInAdvance from '../enums/TrailDetailsDaysInAdvance';
import { getAmplitudeInstance } from '../amplitudeHelpers';

type logTrailDetailsDateSelectedParams = {
  days_in_advance?: TrailDetailsDaysInAdvance;
  trail_id?: number;
};

/**
 * The user can click to view the weather forecast for the next 7 days.
 * @param params - Attributes to log with the amplitude event
 * @param params.days_in_advance - The days in advance the user selects to view the weather or other conditions. 0 is the default and represents the current day. This event is fired only when users make a selection outside the default.
 * @param params.trail_id - the trail id of the item the user selected
 */
const logTrailDetailsDateSelected = ({ days_in_advance, trail_id }: logTrailDetailsDateSelectedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('trail details date selected', { 'days in advance': days_in_advance, 'trail id': trail_id }, callback);
};

export default logTrailDetailsDateSelected;
